import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Store } from '@softline/core';
import { default as deLang } from '../i18n/de.json';
import { default as enLang } from '../i18n/en.json';
import { default as deLoc } from '../l10n/de.json';
import { UiCoreComponentsModule } from './components/ui-core-components.module';
import { UiCoreDirectivesModule } from './directives/ui-core-directives.module';
import { I18nModule } from './i18n/i18n.module';
import { provideI18N, provideTranslation } from './i18n/i18n.providers';
import { L10nModule } from './l10n/l10n.module';
import { provideLocalization } from './l10n/l10n.providers';
import { SOFTLINE_FEATURE_LOCALIZATION } from './l10n/l10n.shared';
import * as LocalizationStore from './l10n/localization.store';
import { MessageBarModule } from './message-bar/message-bar.module';
import { ModalModule } from './modal/legacy/modal.module';
import { provideModals } from './modal/modal.providers';
import { UiCorePipesModule } from './pipes/ui-core-pipes.module';
import { DateParser } from './services/date.parser';
import { IsoDateParser } from './services/iso-date.parser';
import { IsoTimeParser } from './services/iso-time-parser';
import { PreviewService } from './services/preview.service';
import { TimeParser } from './services/time.parser';
import { BreakpointModule } from './utilities/breakpoints/breakpoint.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,

    PortalModule,

    MessageBarModule,
    I18nModule,
    L10nModule,

    UiCoreComponentsModule,
    UiCorePipesModule,
    UiCoreDirectivesModule,
  ],
  exports: [
    MessageBarModule,

    I18nModule,
    L10nModule,

    UiCorePipesModule,
    UiCoreDirectivesModule,
    UiCoreComponentsModule,
  ],
})
export class UiCoreModule {
  static forRoot(): ModuleWithProviders<UiCoreRootModule> {
    return {
      ngModule: UiCoreRootModule,
    };
  }
}

@NgModule({
  imports: [
    UiCoreModule,
    PlatformModule,
    LayoutModule,
    L10nModule.forRoot(),
    MessageBarModule.forRoot(),
    BreakpointModule.forRoot(),
    ModalModule.forRoot(),
  ],
  exports: [UiCoreModule],
  providers: [
    provideI18N(),
    provideTranslation({
      module: 'ui-core',
      language: 'de',
      translations: deLang,
    }),
    provideTranslation({
      module: 'ui-core',
      language: 'en',
      translations: enLang,
    }),
    provideLocalization({
      module: 'ui-core',
      locale: 'de',
      formats: deLoc,
    }),
    provideModals(),
    PreviewService,
    { provide: DateParser, useClass: IsoDateParser },
    { provide: TimeParser, useClass: IsoTimeParser },
  ],
})
export class UiCoreRootModule {
  constructor(store: Store) {
    store.commit(SOFTLINE_FEATURE_LOCALIZATION, LocalizationStore.mutations.add, {
      module: 'ui-core',
      locale: 'de',
      formats: deLoc,
    });
  }
}
